import React from 'react';

const donationHeaderAdvent = ({ firstName = '' } = {}) => (
  <div>
    <h2
      style={{
        fontSize: '40px',
        textAlign: 'center',
        fontFamily: 'proxima-nova, sans-serif',
        color: '#4a4a4a',
      }}
    >
      Good News {firstName}! "Arrival" is on its way to your inbox.
    </h2>
    <br></br>
    <div>
      <p>
        We praise the Lord for your desire to draw closer to Him through His
        Word this year. It’s our prayer that this resource will encourage you
        with the promise that{' '}
        <em>
          “the law of the Lord is perfect, reviving the soul; the testimony of
          the Lord is sure”
        </em>{' '}
        (Psalm 19:7, ESV).
      </p>
      <p>
        The Billy Graham Evangelistic Association is able to offer the hope of
        Jesus Christ through materials like this because of friends like you.
        The Lord is using the gifts and prayers of other believers to reach
        people across the globe with the Gospel—and there are so many more who
        need to hear the Good News of Jesus. If the Lord is leading you, you can
        be a part of this ministry by giving a secure donation today.
      </p>
      <a href="https://giving.billygraham.org/" className="button is-primary">
        <strong>Help Now</strong>
      </a>
    </div>
  </div>
);

export default donationHeaderAdvent;
